import type { MapSettings } from '../types/project.js';

/**
 * Карта и камера по умолчанию для новых проектов и запасных значений (редактор, загрузки без координат).
 * Центр: [долгота, широта].
 */
export const DEFAULT_PROJECT_MAP_VIEW: Pick<
  MapSettings,
  'center' | 'zoom' | 'pitch' | 'bearing' | 'mapStyleKey'
> = {
  center: [43.82491, 56.40581],
  zoom: 5.17,
  pitch: 0,
  bearing: 0,
  mapStyleKey: 'white',
};

/** Формат react-map-gl для начального вида карты. */
export const DEFAULT_PROJECT_INITIAL_VIEW_STATE = {
  longitude: DEFAULT_PROJECT_MAP_VIEW.center[0],
  latitude: DEFAULT_PROJECT_MAP_VIEW.center[1],
  zoom: DEFAULT_PROJECT_MAP_VIEW.zoom,
  pitch: DEFAULT_PROJECT_MAP_VIEW.pitch,
  bearing: DEFAULT_PROJECT_MAP_VIEW.bearing,
} as const;
